module.exports = __webpack_public_path__ + "3639b56d142de4853e1ce64e581bb802.pdf";